"use struct";

(function ($, gsap, ScrollMagic) {

  require('animation.gsap');

  var controller = new ScrollMagic.Controller();


  $(document).ready(function () {
    TweenLite.defaultOverwrite = false;

    effectOnlyOpacity('body', 'section', 1, 0);
    effectOpacity('header', 'div > ul > li', 0.9, 0.1);
    effectOpacity('.header-menu__logo', '.header-menu__logo, .header-menu-fixed__logo', 0.6, 0.1);

    if ($('.content-over-image__container').length > 0) {

      $('.content-left .content-over-image__container').each(function () {

        var sectionID = replaceClass($(this).closest('section').attr('class'));

        if ($(window).width() > 767) {
          effectOpacity(sectionID, sectionID + ' .content-over-image__container', 0.6, 0.2, 1, 0.7, '-50%', '-15%');
        }
        effectOpacity(sectionID, sectionID + ' .content-over-image__image', 0.6, 0.2, 1, 0.7);

      });

      $('.content-right .content-over-image__container').each(function () {
        var sectionID = replaceClass($(this).closest('section').attr('class'));
        if ($(window).width() > 1200) {
          effectOpacity(sectionID, sectionID + ' .content-over-image__container', 0.6, 0.2, 1, 0.7, '-50%', '-65%');
        } else if ($(window).width() > 767 && $(window).width() <= 1200) {
          effectOpacity(sectionID, sectionID + ' .content-over-image__container', 0.6, 0.2, 1, 0.7, '-50%', '-55%');
        }
        effectOpacity(sectionID, sectionID + ' .content-over-image__image', 0.6, 0.2, 1, 0.7, '0', '0');

      });
    }

    if ($('.fade-in-opacity').length > 0) {
      $('.fade-in-opacity').each(function () {
        var sectionID = replaceClass($(this).closest('section').attr('class'));
        effectOpacity(sectionID, sectionID + ' .fade-in-opacity', 0.6, 0.2, 1, 0.6);
      });
    }

    if ($('.follow-us__social').length > 0) {
      $('.follow-us__social').each(function () {
        var sectionID = replaceClass($(this).closest('section').attr('class'));
        effectOpacity(sectionID, sectionID + ' .follow-us__social', 0.6, 0.2, 1, 0.6);
      });
    }

    if ($('.features__items').length > 0) {
      $('.features__items').each(function () {
        var sectionID = replaceClass($(this).closest('section').attr('class'));
        effectOpacity(sectionID, sectionID + ' .features__items > div', 1, 0.2, 1, 0.2);
      });
    }

    if ($('.advisors-managers__list').length > 0) {
      $('.advisors-managers__list').each(function () {
        var sectionID = replaceClass($(this).closest('section').attr('class'));
        effectOpacity(sectionID, sectionID + ' .advisors-managers__list > div', 1, 0.2, 1, 0.4);
      });
    }

    if ($('footer').length > 0) {
      effectOpacity('footer', 'footer div', 0.3, 0.1, 1, 0.9);
    }

  });

  /* Parallax Effect */

  effectParallax = function (container, ele, percent, zindex, heightDuration) {

    var tween = TweenMax
      .to(ele, 1, {
        //repeat: 15,
        x: 0,
        y: 0,
        opacity: percent,
        ease: Linear.easeNone,
        yoyo: true,
        force3D: true,
        zIndex: zindex,
        transformStyle: "preserve-3d",
        transformPerspective: 600

      });

    var scene = new ScrollMagic.Scene({
      triggerElement: container,
      duration: heightDuration
    }).setTween(tween)
      .addTo(controller)
      .triggerHook(0.8);
  }

  /* Opacity effect */

  effectOpacity = function (container, ele, effectSpeed, speedBetweenEle, opacityVal, trigger, cordY, cordX) {

    var opacityVal = opacityVal || 1;
    var trigger = trigger || 0.8;
    var cordY = cordY || 0;
    var cordX = cordX || 0;


    var tween = TweenMax
      .staggerTo(ele, effectSpeed, {
        opacity: opacityVal,
        y: cordY,
        x: cordX,
        force3D: true,
        ease: Linear.easeNone
      }, speedBetweenEle);

    var scene = new ScrollMagic.Scene({
      triggerElement: container,
    }).setTween(tween)
      .addTo(controller)
      .triggerHook(trigger);
  }

  effectOnlyOpacity = function (container, ele, effectSpeed, speedBetweenEle, opacityVal, trigger) {

    var opacityVal = opacityVal || 1;
    var trigger = trigger || 0.8;

    var tween = TweenMax
      .staggerTo(ele, effectSpeed, {
        opacity: opacityVal,
        ease: Linear.easeNone
      }, speedBetweenEle);

    var scene = new ScrollMagic.Scene({
      triggerElement: container,
    }).setTween(tween)
      .addTo(controller)
      .triggerHook(trigger);
  }

  function replaceClass(ele) {
    var sectionClass = ele.replace(/\ /g, '.');
    return "." + sectionClass;
  }

  function resetController() {
    return controller.enabled(false);
  }

})(jQuery, Gsap, ScrollMagic);